import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "booking-details-layout" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 col-12" }
const _hoisted_4 = { class: "booking-summary" }
const _hoisted_5 = {
  key: 0,
  class: "field"
}
const _hoisted_6 = { class: "value" }
const _hoisted_7 = {
  key: 1,
  class: "field"
}
const _hoisted_8 = {
  key: 2,
  class: "field"
}
const _hoisted_9 = { class: "field" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "field" }
const _hoisted_15 = { class: "value" }
const _hoisted_16 = {
  key: 3,
  class: "field"
}
const _hoisted_17 = { class: "value" }
const _hoisted_18 = {
  key: 4,
  class: "field"
}
const _hoisted_19 = { class: "value cancellation-dates" }
const _hoisted_20 = {
  key: 5,
  class: "field"
}
const _hoisted_21 = {
  key: 0,
  class: "value"
}
const _hoisted_22 = {
  key: 1,
  class: "value fw-bold"
}
const _hoisted_23 = {
  key: 2,
  class: "value fw-bold"
}
const _hoisted_24 = {
  key: 6,
  class: "field"
}
const _hoisted_25 = { class: "value" }
const _hoisted_26 = {
  key: 7,
  class: "field"
}
const _hoisted_27 = {
  key: 0,
  class: "value"
}
const _hoisted_28 = ["href"]
const _hoisted_29 = {
  key: 1,
  class: "value"
}
const _hoisted_30 = ["href"]
const _hoisted_31 = {
  key: 8,
  class: "field description-field"
}
const _hoisted_32 = { class: "value" }
const _hoisted_33 = { class: "col-lg-6 col-12" }
const _hoisted_34 = { class: "logs-section" }
const _hoisted_35 = {
  key: 0,
  class: "logs-skeleton"
}
const _hoisted_36 = { class: "logs-container" }
const _hoisted_37 = { class: "log-header" }
const _hoisted_38 = { class: "log-action-wrapper" }
const _hoisted_39 = {
  key: 0,
  class: "log-series-marker",
  title: "Ereignis der Serie"
}
const _hoisted_40 = { class: "log-time" }
const _hoisted_41 = { class: "log-user" }
const _hoisted_42 = ["onMouseenter"]
const _hoisted_43 = {
  key: 0,
  class: "log-changes"
}
const _hoisted_44 = { class: "change-field" }
const _hoisted_45 = { class: "change-values" }
const _hoisted_46 = { class: "old-value" }
const _hoisted_47 = { class: "new-value" }
const _hoisted_48 = {
  key: 0,
  class: "extracted-note"
}
const _hoisted_49 = { class: "log-created" }
const _hoisted_50 = { class: "created-summary" }
const _hoisted_51 = { class: "created-info" }
const _hoisted_52 = {
  key: 0,
  class: "created-info"
}
const _hoisted_53 = {
  key: 1,
  class: "created-person"
}
const _hoisted_54 = { class: "log-cancelled" }
const _hoisted_55 = { class: "cancelled-message" }
const _hoisted_56 = {
  key: 0,
  class: "user-tooltip-displayname"
}
const _hoisted_57 = { class: "user-tooltip-username" }
const _hoisted_58 = { class: "user-tooltip-displayname" }
const _hoisted_59 = {
  key: 0,
  class: "user-tooltip-id"
}
const _hoisted_60 = { class: "user-tooltip-username" }

import { computed, ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import { useMasterDataHelpers } from "../composables/useMasterDataHelpers.js";
import { useBookingLogsQuery } from "../../api/queries/bookingQueries.js";
import { useRRuleBuilder } from "../composables/useRRuleBuilder";
import { useFloating, autoUpdate, offset, flip, shift } from "@floating-ui/vue";
import { getActionLabel, isSeriesLevelLog } from "../../composables/useLogDisplay.js";
import { getBookingTypeLabel } from "../utils/bookingTypeLabel.js";


export default {
  __name: 'BookingDetailsView',
  props: {
	booking: {
		type: Object,
		required: true,
	},
},
  setup(__props) {

const props = __props;

// Get master data helpers
const { getBookingTypeById, getRoomById } = useMasterDataHelpers();

// Booking logs query - auto-load when booking ID is available
const logsQueryConfig = computed(() =>
	useBookingLogsQuery(props.booking?.id, !!props.booking?.id)
);
const {
	data: logsData,
	isLoading: logsLoading,
	error: logsError,
} = useQuery(logsQueryConfig);

// User tooltip state
const userElement = ref(null);
const userTooltipEl = ref(null);
const showUserTooltipState = ref(false);
const currentUser = ref(null);
let tooltipTimeout = null;

// Booking owner tooltip state
const bookingOwnerElement = ref(null);
const bookingOwnerTooltipEl = ref(null);
const showBookingOwnerTooltipState = ref(false);
let bookingOwnerTooltipTimeout = null;

// Setup floating UI for user tooltip
const { floatingStyles: userTooltipStyles } = useFloating(
	computed(() => userElement.value),
	userTooltipEl,
	{
		middleware: [offset(8), flip(), shift({ padding: 5 })],
		whileElementsMounted: autoUpdate,
	}
);

// Setup floating UI for booking owner tooltip
const { floatingStyles: bookingOwnerTooltipStyles } = useFloating(
	computed(() => bookingOwnerElement.value),
	bookingOwnerTooltipEl,
	{
		middleware: [offset(8), flip(), shift({ padding: 5 })],
		whileElementsMounted: autoUpdate,
	}
);

// Get booking type for display
const bookingType = computed(() => {
	if (!props.booking?.bookingTypeId) return null;
	return getBookingTypeById.value(props.booking.bookingTypeId);
});

// Get room for display
const room = computed(() => {
  if (!props.booking?.roomId) return null;
  return getRoomById.value(props.booking.roomId);
});


// Calculate end date for series
const calculateEndDateForSeries = (series) => {
  try {
    // Use RRule to calculate the actual last occurrence
    const rruleBuilder = useRRuleBuilder();
    const lastDate = rruleBuilder.calculateEndDate(series.startTime, series.pattern);

    if (lastDate) {
      return lastDate;
    }

    // Simple fallback: if we can't calculate with RRule, don't show an end date
    console.warn("Could not calculate series end date for pattern:", series.pattern);
    return null;
  } catch (error) {
    console.error("Error calculating series end date:", error);
    return null;
  }
};

// Generate human-readable pattern with effective count (active appointments)
const humanReadablePattern = (series) => {
  const basePattern = useRRuleBuilder().getHumanReadable(series.pattern);

  // Parse the count from the pattern
  const countMatch = series.pattern.match(/COUNT=(\d+)/);
  if (!countMatch) return basePattern;

  const totalCount = parseInt(countMatch[1]);

  const occurrenceDateStrings = useRRuleBuilder()
    .getOccurrenceDates(series.startTime, series.pattern)
    .map((date) => date.toISOString().split("T")[0]);
  const activeCancellations = (series.cancellations || [])
    .filter((date) => occurrenceDateStrings.includes(date));
  const effectiveCount = totalCount - activeCancellations.length;

  // Handle different pattern formats
  let updatedPattern = basePattern;

  // Try to replace existing count (e.g., "4 mal" -> "3 mal")
  if (basePattern.match(/\d+\s*mal/)) {
    updatedPattern = basePattern.replace(/\d+\s*mal/, `${effectiveCount} mal`);
  }
  // For patterns that might not have "X mal", append it
  else if (basePattern.match(/Jeden Tag|Täglich/i)) {
    // Check if it ends with a comma or period
    if (basePattern.match(/[,.]$/)) {
      updatedPattern = basePattern.replace(/[,.]$/, `, ${effectiveCount} mal`);
    } else {
      updatedPattern = `${basePattern}, ${effectiveCount} mal`;
    }
  }
  // For other patterns without "X mal", try to append
  else {
    updatedPattern = `${basePattern}, ${effectiveCount} mal`;
  }

  return updatedPattern;
};

// Sort a series' cancellation dates chronologically for display (one per line) — the
// array's stored order reflects when each date was excluded, not the date itself
const sortedCancellationDates = (datesArray) => {
  return [...datesArray].sort();
};

// Format date for display
const formatDate = (dateStr) => {
	if (!dateStr) return "";

	try {
		let date;

		// Handle different date formats
		if (typeof dateStr === "string") {
			if (dateStr.includes("T")) {
				// ISO datetime string
				date = new Date(dateStr);
			} else if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
				// YYYY-MM-DD format
				date = new Date(dateStr + "T00:00:00");
			} else {
				// Try parsing directly
				date = new Date(dateStr);
			}
		} else {
			// Assume it's already a Date object or timestamp
			date = new Date(dateStr);
		}

		// Check if date is valid
		if (isNaN(date.getTime())) {
			console.warn("Invalid date:", dateStr);
			return dateStr;
		}

		return date.toLocaleDateString("de-DE", {
			weekday: "short",
			day: "2-digit",
			month: "2-digit",
			year: "numeric",
		});
	} catch (error) {
		console.warn("Date formatting error:", error, dateStr);
		return dateStr;
	}
};

// Format time for display
const formatTime = (timeStr) => {
	if (!timeStr) return "";

	// Handle both time strings and ISO datetime strings
	try {
		if (timeStr.includes("T")) {
			const date = new Date(timeStr);
			return date.toLocaleTimeString("de-DE", {
				hour: "2-digit",
				minute: "2-digit",
			});
		}

		// For simple time strings like "14:00"
		if (timeStr.match(/^\d{2}:\d{2}(:\d{2})?$/)) {
			return timeStr.substring(0, 5); // Just take HH:MM part
		}

		return timeStr;
	} catch (error) {
		return timeStr;
	}
};

// Format date and time together
const formatDateTime = (dateTimeStr) => {
	if (!dateTimeStr) return "";

	try {
		const date = new Date(dateTimeStr);

		// Check if date is valid
		if (isNaN(date.getTime())) {
			return dateTimeStr;
		}

		const dateStr = date.toLocaleDateString("de-DE", {
			weekday: "short",
			day: "2-digit",
			month: "2-digit",
			year: "numeric",
		});

		const timeStr = date.toLocaleTimeString("de-DE", {
			hour: "2-digit",
			minute: "2-digit",
		});

		return `${dateStr}, ${timeStr}`;
	} catch (error) {
		console.warn("DateTime formatting error:", error);
		return dateTimeStr;
	}
};

// Format duration
const formatDuration = (startTime, endTime) => {
	if (!startTime || !endTime) return "";

	try {
		const start = new Date(startTime);
		const end = new Date(endTime);

		// Check if dates are valid
		if (isNaN(start.getTime()) || isNaN(end.getTime())) {
			return "";
		}

		const durationMs = end.getTime() - start.getTime();
		const durationMinutes = Math.floor(durationMs / (1000 * 60));

		if (durationMinutes < 60) {
			return `${durationMinutes} Min`;
		}

		const hours = Math.floor(durationMinutes / 60);
		const minutes = durationMinutes % 60;

		if (minutes === 0) {
			return `${hours} ${hours === 1 ? "Stunde" : "Stunden"}`;
		}

		return `${hours}:${minutes.toString().padStart(2, "0")} Std`;
	} catch (error) {
		console.warn("Duration formatting error:", error);
		return "";
	}
};

// Format a recurrence pattern (RRULE string) for display
const formatPattern = (pattern) => {
	if (!pattern) return "";
	try {
		return useRRuleBuilder().getHumanReadable(pattern);
	} catch (error) {
		console.warn("Pattern formatting error:", error);
		return pattern;
	}
};

// Format log date time with full timestamp
const formatLogDateTime = (dateTimeStr) => {
	if (!dateTimeStr) return "";

	try {
		const date = new Date(dateTimeStr);

		if (isNaN(date.getTime())) {
			return dateTimeStr;
		}

		const now = new Date();
		const isToday = date.toDateString() === now.toDateString();
		const yesterday = new Date(now);
		yesterday.setDate(yesterday.getDate() - 1);
		const isYesterday = date.toDateString() === yesterday.toDateString();

		let dateStr;
		if (isToday) {
			dateStr = "Heute";
		} else if (isYesterday) {
			dateStr = "Gestern";
		} else {
			dateStr = date.toLocaleDateString("de-DE", {
				weekday: "short",
				day: "2-digit",
				month: "2-digit",
				year: date.getFullYear() !== now.getFullYear() ? "numeric" : undefined,
			});
		}

		const timeStr = date.toLocaleTimeString("de-DE", {
			hour: "2-digit",
			minute: "2-digit",
		});

		return `${dateStr}, ${timeStr}`;
	} catch (error) {
		return dateTimeStr;
	}
};

// Value equality that treats arrays (e.g. a series' cancellation date list) by content,
// not by reference — the backend always sends full old/new snapshots, so an unchanged
// array-valued field would otherwise show up as "changed" via plain !== reference comparison
const valuesAreEqual = (a, b) => {
	if (Array.isArray(a) && Array.isArray(b)) {
		return a.length === b.length && a.every((value, index) => value === b[index]);
	}
	return a === b;
};

// Get summary of changes for 'changed' action
const getChangeSummary = (changes) => {
	if (!changes?.old || !changes?.new) return [];

	const oldData = changes.old;
	const newData = changes.new;
	const changeSummary = [];

	// Check for changed fields
	Object.keys(newData).forEach((key) => {
		if (!valuesAreEqual(oldData[key], newData[key]) && shouldShowFieldInSummary(key)) {
			changeSummary.push({
				field: getFieldLabel(key),
				oldValue: formatFieldValueForSummary(key, oldData[key], oldData),
				newValue: formatFieldValueForSummary(key, newData[key], newData),
			});
		}
	});

	return changeSummary;
};

// Check if field should be shown in change summary
const shouldShowFieldInSummary = (key) => {
	const hiddenFields = [
		"isCancelled",
		"studentData",
		"employeeData",
		"bookingTypeData",
		"roomData",
		"modifiedAt",
	];
	return !hiddenFields.includes(key);
};

// Get field label for display
const getFieldLabel = (key) => {
	const labels = {
		startTime: "Start",
		endTime: "Ende",
		title: "Titel",
		description: "Beschreibung",
		room: "Raum",
		employee: "Mitarbeiter",
		student: "Student",
		bookingType: "Typ",
		series: "Serie",
		pattern: "Wiederholung",
		cancellations: "Ausfalltermine",
	};
	return labels[key] || key;
};

// Format a list of Y-m-d date strings (e.g. a series' excluded dates)
const formatDateList = (dates) => {
	if (!Array.isArray(dates) || dates.length === 0) return "Keine";
	return dates.map((date) => formatDate(date)).join(", ");
};

// Format field value for summary display
const formatFieldValueForSummary = (key, value, dataObject) => {
  if (key === 'series') return value ? 'Ja' : 'Nein';
  if (key === 'cancellations') return formatDateList(value);
  if (key === 'title' && !value) return "Kein Titel";
  if (key === 'description' && !value) return "Keine Beschreibung";
  if (value === null || value === undefined) return "-";

	switch (key) {
		case "startTime":
		case "endTime":
			// full date+time, not just formatTime()'s HH:MM — otherwise a date-only change
			// (e.g. a series occurrence reused for a different week at the same time of
			// day) renders old/new as identical-looking values, which reads as "nothing
			// changed" even though the diff was correctly detected
			return formatDateTime(value);
    case "bookingType":
			return getBookingTypeById.value(value)?.title || `Typ ${value}`;
		case "pattern":
			return formatPattern(value);
		case "room":
			if (dataObject?.roomData) {
				const parts = [
					dataObject.roomData.building?.short,
					dataObject.roomData.doorLabel,
					dataObject.roomData.name
				].filter(Boolean);
				return parts.join(' ') || `Raum ${value}`;
			}
			return `Raum ${value}`;
		default:
			return value.toString();
	}
};

// Format time range for created bookings
const formatTimeRange = (startTime, endTime) => {
	if (!startTime || !endTime) return "";

	const start = formatTime(startTime);
	const end = formatTime(endTime);

	return `${start} - ${end}`;
};

// Get person name from booking data
const getPersonName = (data) => {
	if (data.studentData) {
		return (
			data.studentData.displayName ||
			`${data.studentData.firstname} ${data.studentData.lastname}`
		);
	}
	if (data.employeeData) {
		return (
			data.employeeData.displayName ||
			`${data.employeeData.firstname} ${data.employeeData.lastname}`
		);
	}
	return "";
};

// User tooltip methods
const showUserTooltip = async (event, user) => {
	if (!user?.username) return;
	
	// Clear any existing timeout
	if (tooltipTimeout) {
		clearTimeout(tooltipTimeout);
		tooltipTimeout = null;
	}
	
	userElement.value = event.target;
	currentUser.value = user;
	showUserTooltipState.value = true;
};

const hideUserTooltip = () => {
	// Add small delay to prevent flickering when moving mouse
	tooltipTimeout = setTimeout(() => {
		showUserTooltipState.value = false;
		currentUser.value = null;
	}, 150);
};

const onTooltipMouseEnter = () => {
	// Cancel hide timeout when mouse enters tooltip
	if (tooltipTimeout) {
		clearTimeout(tooltipTimeout);
		tooltipTimeout = null;
	}
};

const onTooltipMouseLeave = () => {
	// Hide tooltip when mouse leaves
	hideUserTooltip();
};

// Booking owner tooltip methods
const showBookingOwnerTooltip = async (event) => {
	if (!props.booking || (!props.booking.student && !props.booking.employee)) return;
	
	// Clear any existing timeout
	if (bookingOwnerTooltipTimeout) {
		clearTimeout(bookingOwnerTooltipTimeout);
		bookingOwnerTooltipTimeout = null;
	}
	
	bookingOwnerElement.value = event.target;
	showBookingOwnerTooltipState.value = true;
};

const hideBookingOwnerTooltip = () => {
	// Add small delay to prevent flickering when moving mouse
	bookingOwnerTooltipTimeout = setTimeout(() => {
		showBookingOwnerTooltipState.value = false;
	}, 150);
};

const onBookingOwnerTooltipMouseEnter = () => {
	// Cancel hide timeout when mouse enters tooltip
	if (bookingOwnerTooltipTimeout) {
		clearTimeout(bookingOwnerTooltipTimeout);
		bookingOwnerTooltipTimeout = null;
	}
};

const onBookingOwnerTooltipMouseLeave = () => {
	// Hide tooltip when mouse leaves
	hideBookingOwnerTooltip();
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createCommentVNode(" Left Column - Booking Info "),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createCommentVNode(" Title "),
            (__props.booking.title?.trim())
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "label" }, "Titel", -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(__props.booking.title), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Type "),
            (bookingType.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "label" }, "Nutzungsart", -1 /* CACHED */)),
                  _createElementVNode("span", {
                    class: "value type-badge",
                    style: _normalizeStyle({
                backgroundColor: bookingType.value.backgroundColor || '#6b7280',
                color: bookingType.value.textColor || '#fff',
              })
                  }, _toDisplayString(bookingType.value.title), 5 /* TEXT, STYLE */)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Room "),
            (room.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "label" }, "Raum", -1 /* CACHED */)),
                  _createElementVNode("span", null, _toDisplayString(room.value.building.short) + " " + _toDisplayString(room.value.doorLabel) + " " + _toDisplayString(room.value.name), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Start "),
            _createElementVNode("div", _hoisted_9, [
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "label" }, "Start", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_10, [
                _createTextVNode(_toDisplayString(formatDateTime(__props.booking.startTime)) + " ", 1 /* TEXT */),
                (__props.booking.series)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "⟲"))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createCommentVNode(" End "),
            _createElementVNode("div", _hoisted_12, [
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "label" }, "Ende", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_13, _toDisplayString(formatDateTime(__props.booking.endTime)), 1 /* TEXT */)
            ]),
            _createCommentVNode(" Duration "),
            _createElementVNode("div", _hoisted_14, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "Dauer", -1 /* CACHED */)),
              _createElementVNode("span", _hoisted_15, _toDisplayString(formatDuration(__props.booking.startTime, __props.booking.endTime)), 1 /* TEXT */)
            ]),
            _createCommentVNode(" Series "),
            (__props.booking.series)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "label" }, "Serie", -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(humanReadablePattern(__props.booking.series)) + ", vom " + _toDisplayString(formatDate(__props.booking.series.startTime)) + " bis " + _toDisplayString(formatDate(calculateEndDateForSeries(__props.booking.series))) + ". ", 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Series cancellation dates "),
            (__props.booking.series?.cancellations?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "label" }, "Ausfalltermine", -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedCancellationDates(__props.booking.series.cancellations), (date) => {
                      return (_openBlock(), _createElementBlock("span", { key: date }, _toDisplayString(formatDate(date)), 1 /* TEXT */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Points "),
            (__props.booking.student)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _cache[12] || (_cache[12] = _createElementVNode("span", { class: "label" }, "Buchungstyp", -1 /* CACHED */)),
                  (__props.booking.points)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(__props.booking.points) + " Punkte", 1 /* TEXT */))
                    : (__props.booking.walkIn)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(getBookingTypeLabel)(__props.booking)), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_unref(getBookingTypeLabel)(__props.booking)), 1 /* TEXT */))
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Room "),
            (__props.booking.room)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "label" }, "Raum", -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_25, _toDisplayString(__props.booking.room.name || __props.booking.room.title), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Created for "),
            (__props.booking.student || __props.booking.employee)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "label" }, "Erstellt für", -1 /* CACHED */)),
                  (__props.booking.student)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                        _createCommentVNode(" Booking owner with tooltip and optional link "),
                        (__props.booking.student.url)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: __props.booking.student.url,
                              target: "_blank",
                              onMouseenter: _cache[0] || (_cache[0] = $event => (showBookingOwnerTooltip($event))),
                              onMouseleave: hideBookingOwnerTooltip
                            }, _toDisplayString(__props.booking.student.displayName), 41 /* TEXT, PROPS, NEED_HYDRATION */, _hoisted_28))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              onMouseenter: _cache[1] || (_cache[1] = $event => (showBookingOwnerTooltip($event))),
                              onMouseleave: hideBookingOwnerTooltip
                            }, _toDisplayString(__props.booking.student.displayName), 33 /* TEXT, NEED_HYDRATION */))
                      ]))
                    : (__props.booking.employee)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                          _createCommentVNode(" Booking owner with tooltip and optional link "),
                          (__props.booking.employee.url)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: __props.booking.employee.url,
                                target: "_blank",
                                onMouseenter: _cache[2] || (_cache[2] = $event => (showBookingOwnerTooltip($event))),
                                onMouseleave: hideBookingOwnerTooltip
                              }, _toDisplayString(__props.booking.employee.displayName), 41 /* TEXT, PROPS, NEED_HYDRATION */, _hoisted_30))
                            : (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                onMouseenter: _cache[3] || (_cache[3] = $event => (showBookingOwnerTooltip($event))),
                                onMouseleave: hideBookingOwnerTooltip
                              }, _toDisplayString(__props.booking.employee.displayName), 33 /* TEXT, NEED_HYDRATION */))
                        ]))
                      : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Description "),
            (__props.booking.description?.trim())
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "Beschreibung", -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(__props.booking.description), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createCommentVNode(" Right Column - Logs "),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createCommentVNode(" Loading State "),
            (_unref(logsLoading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                    return _createElementVNode("div", {
                      key: n,
                      class: "skeleton-log-entry"
                    }, [...(_cache[16] || (_cache[16] = [
                      _createStaticVNode("<div class=\"d-flex justify-content-between mb-2\"><div class=\"skeleton skeleton-action\"></div><div class=\"skeleton skeleton-time\"></div></div><div class=\"skeleton skeleton-user mb-1\"></div><div class=\"skeleton skeleton-details\"></div>", 3)
                    ]))])
                  }), 64 /* STABLE_FRAGMENT */))
                ]))
              : (_unref(logsError))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createCommentVNode(" Error State "),
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "text-danger" }, [
                      _createElementVNode("small", null, [
                        _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }),
                        _createTextVNode(" Fehler beim Laden des Protokolls ")
                      ])
                    ], -1 /* CACHED */))
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                : (_unref(logsData)?.logs?.length === 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createCommentVNode(" Empty State "),
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "text-muted text-center py-4" }, [
                        _createElementVNode("i", {
                          class: "fas fa-file-alt mb-2",
                          style: {"font-size":"2rem"}
                        }),
                        _createElementVNode("div", { class: "small" }, " Keine Protokolleinträge gefunden ")
                      ], -1 /* CACHED */))
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  : (_unref(logsData)?.logs?.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createCommentVNode(" Logs List "),
                        _createElementVNode("div", _hoisted_36, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(logsData).logs, (log) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: log.id,
                              class: "log-entry"
                            }, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["log-action-badge", 'action-' + log.action])
                                  }, [
                                    (_unref(isSeriesLevelLog)(log))
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, "⟲"))
                                      : _createCommentVNode("v-if", true),
                                    _createTextVNode(" " + _toDisplayString(_unref(getActionLabel)(log.action)), 1 /* TEXT */)
                                  ], 2 /* CLASS */),
                                  _createElementVNode("span", _hoisted_40, _toDisplayString(formatLogDateTime(log.logDate)), 1 /* TEXT */)
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("span", {
                                    class: "user-display",
                                    onMouseenter: $event => (showUserTooltip($event, log.user)),
                                    onMouseleave: hideUserTooltip
                                  }, _toDisplayString(log.user?.displayName || log.user?.username), 41 /* TEXT, PROPS, NEED_HYDRATION */, _hoisted_42)
                                ])
                              ]),
                              _createCommentVNode(" Changes Summary for 'changed'/'extracted' action "),
                              ((log.action === 'changed' || log.action === 'extracted') && log.changes)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getChangeSummary(log.changes), (change) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: change.field,
                                        class: "change-item"
                                      }, [
                                        _createElementVNode("span", _hoisted_44, _toDisplayString(change.field), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_45, [
                                          _createElementVNode("span", _hoisted_46, _toDisplayString(change.oldValue), 1 /* TEXT */),
                                          _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fas fa-arrow-right mx-1" }, null, -1 /* CACHED */)),
                                          _createElementVNode("span", _hoisted_47, _toDisplayString(change.newValue), 1 /* TEXT */)
                                        ])
                                      ]))
                                    }), 128 /* KEYED_FRAGMENT */)),
                                    (log.action === 'extracted')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, " Dieser Termin wurde aus der Serie gelöst. "))
                                      : _createCommentVNode("v-if", true)
                                  ]))
                                : (log.action === 'created' && log.changes?.new)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createCommentVNode(" Created Summary "),
                                      _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("div", _hoisted_50, [
                                          _createElementVNode("span", _hoisted_51, [
                                            _cache[20] || (_cache[20] = _createElementVNode("i", { class: "fas fa-clock me-1" }, null, -1 /* CACHED */)),
                                            _createTextVNode(" " + _toDisplayString(formatTimeRange(
                        log.changes.new.startTime,
                        log.changes.new.endTime
                      )), 1 /* TEXT */)
                                          ]),
                                          (log.changes.new.pattern)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                                                _cache[21] || (_cache[21] = _createElementVNode("i", { class: "fas fa-repeat me-1" }, null, -1 /* CACHED */)),
                                                _createTextVNode(" " + _toDisplayString(formatPattern(log.changes.new.pattern)), 1 /* TEXT */)
                                              ]))
                                            : _createCommentVNode("v-if", true),
                                          (
                      log.changes.new.studentData ||
                        log.changes.new.employeeData
                    )
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(getPersonName(log.changes.new)), 1 /* TEXT */))
                                            : _createCommentVNode("v-if", true)
                                        ])
                                      ])
                                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                  : (log.action === 'cancelled')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createCommentVNode(" Cancelled Message "),
                                        _createElementVNode("div", _hoisted_54, [
                                          _createElementVNode("span", _hoisted_55, _toDisplayString(_unref(isSeriesLevelLog)(log) ? 'Serie wurde storniert' : 'Buchung wurde storniert'), 1 /* TEXT */)
                                        ])
                                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
          ])
        ])
      ])
    ]),
    _createCommentVNode(" User Tooltip "),
    (showUserTooltipState.value && currentUser.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "userTooltipEl",
          ref: userTooltipEl,
          style: _normalizeStyle(_unref(userTooltipStyles)),
          class: "user-tooltip",
          onMouseenter: onTooltipMouseEnter,
          onMouseleave: onTooltipMouseLeave
        }, [
          (currentUser.value.displayName && currentUser.value.displayName !== currentUser.value.username)
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                _cache[22] || (_cache[22] = _createElementVNode("i", { class: "fa-solid fa-user" }, null, -1 /* CACHED */)),
                _createTextVNode(" " + _toDisplayString(currentUser.value.displayName), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_57, [
            _cache[23] || (_cache[23] = _createElementVNode("i", { class: "fa-solid fa-key" }, null, -1 /* CACHED */)),
            _createTextVNode(" " + _toDisplayString(currentUser.value.username), 1 /* TEXT */)
          ])
        ], 36 /* STYLE, NEED_HYDRATION */))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Booking Owner Tooltip "),
    (showBookingOwnerTooltipState.value && (__props.booking.student || __props.booking.employee))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          ref_key: "bookingOwnerTooltipEl",
          ref: bookingOwnerTooltipEl,
          style: _normalizeStyle(_unref(bookingOwnerTooltipStyles)),
          class: "user-tooltip",
          onMouseenter: onBookingOwnerTooltipMouseEnter,
          onMouseleave: onBookingOwnerTooltipMouseLeave
        }, [
          _createElementVNode("div", _hoisted_58, [
            (__props.booking.student)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[24] || (_cache[24] = _createElementVNode("i", { class: "fa-solid fa-graduation-cap" }, null, -1 /* CACHED */)),
                  _createTextVNode(" " + _toDisplayString(__props.booking.student.firstname) + " " + _toDisplayString(__props.booking.student.lastname), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : (__props.booking.employee)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[25] || (_cache[25] = _createElementVNode("i", { class: "fa-solid fa-chalkboard-user" }, null, -1 /* CACHED */)),
                    _createTextVNode(" " + _toDisplayString(__props.booking.employee.firstname) + " " + _toDisplayString(__props.booking.employee.lastname), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
          ]),
          (__props.booking.student)
            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fa-solid fa-id-card" }, null, -1 /* CACHED */)),
                _createTextVNode(" MNR: " + _toDisplayString(__props.booking.student.id), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_60, [
            (__props.booking.student)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[27] || (_cache[27] = _createElementVNode("i", { class: "fa-solid fa-key" }, null, -1 /* CACHED */)),
                  _createTextVNode(" " + _toDisplayString(__props.booking.student.username), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : (__props.booking.employee && __props.booking.employee.username)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[28] || (_cache[28] = _createElementVNode("i", { class: "fa-solid fa-key" }, null, -1 /* CACHED */)),
                    _createTextVNode(" " + _toDisplayString(__props.booking.employee.username), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : (__props.booking.employee && !__props.booking.employee.username)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _cache[29] || (_cache[29] = _createElementVNode("i", { class: "fa-solid fa-key" }, null, -1 /* CACHED */)),
                      _cache[30] || (_cache[30] = _createTextVNode(" (kein Account) ", -1 /* CACHED */))
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
          ])
        ], 36 /* STYLE, NEED_HYDRATION */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

}